<template>
  <div class="app-container" >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="工资汇总" name="one" style="">
        <gongZiHuiZong v-if="activeName=='one'" ref="monthHeSuan" @switchToDetails="handleSwitchToDetails"></gongZiHuiZong>
      </el-tab-pane>
      <el-tab-pane label="工资明细" name="two">
        <gongZiMingXi v-if="activeName=='two'" ref="hesuanmingxi" :paramsFromParent="paramsFromParent"></gongZiMingXi>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import gongZiHuiZong from '@/views/newTMS/costExpense/newWeiXiu/jiXiu/gongZiHuiZong.vue'
import gongZiMingXi from '@/views/newTMS/costExpense/newWeiXiu/jiXiu/gongZiMingXi.vue'
export default {
  components: {
    gongZiHuiZong, gongZiMingXi
  },
  data () {
    return {
      activeName: 'one',
      paramsFromParent: null
    }
  },
  created () {
    // if (this.$route.query.ZDFlag) {
    //   this.activeName = 'two'
    // } else {
    //   this.activeName = 'one'
    // }
  },
  methods: {
    handleSwitchToDetails (params) {
      this.paramsFromParent = params
      console.log(this.paramsFromParent, 'this.paramsFromParent')
      this.activeName = 'two'
    },
    handleClick (tab) {
      if (tab.name === 'one') {
        // 切换到汇总时清空参数
        this.paramsFromParent = null
      }
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    background-color: #0c46a2 !important;
    color: #fff;
}
/deep/.el-tabs__header{
  margin: 0;
}
</style>
